import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { useMutation } from "@apollo/client";

import { Button, FormGroup, showSnackbar, Tag, TagSize } from "@cofano/cck";
import { Box, Popover } from "@mui/material";

import usePopover from "components/hooks/usePopover";

import RechargeBillingCommentSelect from "../selects/RechargeBillingCommentSelect";

import { UpdateRechargeBillingCommentDocument } from "__generated__/view/recharge/graphql/recharge.mutations.generated";
import { RechargeBillingComment } from "__generated__/enums";

const RechargeBillingCommentStatus = ({
	id,
	value,
	refetch,
}: {
	id: number;
	value: RechargeBillingComment | null;
	refetch: () => void;
}) =>  {

	const [ selectedValue, setSelectedValue ] = useState<RechargeBillingComment | null>(value);
	const isButtonDisabled = selectedValue == value;

	const { popoverProps, onPopoverOpen, onPopoverClose  } = usePopover({
		trigger: "click",
	});

	const [ updateComment, { loading } ] = useMutation(UpdateRechargeBillingCommentDocument);

	const getTag = () => {
		switch (value) {
			case RechargeBillingComment.DeadFreight:
				return <Tag text={intl.formatMessage({ id: "RECHARGE_COMMENT_DEAD_FREIGHT" })} color="#a4c2ee" size={TagSize.SMALL} />;
			case RechargeBillingComment.OldVoyage:
				return <Tag text={intl.formatMessage({ id: "RECHARGE_COMMENT_OLD_VOYAGE" })} color="#f1d65c" size={TagSize.SMALL} />;
			default:
				return <Tag text={intl.formatMessage({ id: "RECHARGE_COMMENT_DEFAULT" })} color="#dbdbdb" size={TagSize.SMALL} />;
		}
	};

	return (
		<React.Fragment>
			<Popover {...popoverProps}>
				<Box p={2}>
					<FormGroup label={intl.formatMessage({ id: "RECHARGE_COMMENT" })} overflow="hidden">
						<RechargeBillingCommentSelect
							value={selectedValue}
							onChange={(v) => setSelectedValue(v)} />
					</FormGroup>

					<div>
						<Button
							onClick={() => {
								updateComment({
									variables: {
										id: id,
										comment: selectedValue,
									},
								}).then(() => {
									onPopoverClose();
									showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
									refetch();
								});
							}}
							disabled={isButtonDisabled || loading}
							loading={loading}
							size="small">
							{intl.formatMessage({ id: "SAVE" })}
						</Button>
					</div>
				</Box>
			</Popover>

			<div style={{ cursor: "pointer" }} onClick={onPopoverOpen}>
				{getTag()}
			</div>
		</React.Fragment>
	);
};

export default RechargeBillingCommentStatus;
